import type { ApplicationClientFinancialObligation } from '../../../types';
import { sumPaidClientObligation } from '../../../utils/applicationClientSettlementProjection';

export type PaymentStepStatus =
  | 'missing'
  | 'waiting'
  | 'done'
  | 'overdue'
  | 'pending_event'
  | 'partially_paid';

export const CLIENT_PAYMENT_TIMELINE_META: Record<
  PaymentStepStatus,
  { label: string; color: string }
> = {
  missing: { label: 'Не оплачено', color: 'default' },
  pending_event: { label: 'Ожидание события', color: 'default' },
  waiting: { label: 'Не оплачено', color: 'gold' },
  partially_paid: { label: 'Частично оплачено', color: 'orange' },
  done: { label: 'Оплачено', color: 'green' },
  overdue: { label: 'Просрочено', color: 'red' },
};

function obligationRemaining(obl: ApplicationClientFinancialObligation | undefined): number {
  if (!obl) return 0;
  return Math.max(0, Number(obl.amountWithVAT ?? 0) - sumPaidClientObligation(obl));
}

export function obligationStepStatus(
  obl: ApplicationClientFinancialObligation | undefined
): PaymentStepStatus {
  if (!obl) return 'missing';
  const status = String(obl.status || '').toUpperCase();
  if (status === 'PAID' || obligationRemaining(obl) <= 0.01) return 'done';
  if (status === 'OVERDUE') return 'overdue';
  if (obl.is_active === false) return 'pending_event';
  if (obl.dueDate == null || String(obl.dueDate).trim() === '') return 'pending_event';
  if (status === 'PARTIALLY_PAID') return 'partially_paid';
  return 'waiting';
}
